export const getLocalToken = () => localStorage.getItem('token');
export const getLocalRefreshToken = () => localStorage.getItem('refresh_token');

// export const saveLocalToken = (token) => localStorage.setItem('token', token);
// export const saveLocalRfreshToken = (refresh_token) => localStorage.setItem('refresh_token', refresh_token);

// export const removeLocalToken = () => localStorage.removeItem('token');
// export const removeLocalRfreshToken = () => localStorage.removeItem('refresh_token');
